import {
  io,
  Socket,
  type ManagerOptions,
  type SocketOptions,
} from 'socket.io-client';

export interface EventsMap {
  [event: string]: unknown;
}

export const socketInstance: <
  ListenEvents extends EventsMap,
  EmitEvents extends EventsMap,
>(
  url: string,
  opts?: Partial<ManagerOptions & SocketOptions>
) => Socket<ListenEvents, EmitEvents> = (url, opts) =>
  io(url, {
    autoConnect: false,
    ...opts,
  });
